import {
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
  ExclamationCircleTwoTone,
  HistoryOutlined,
  HolderOutlined,
  LeftOutlined,
  PlusOutlined,
  WarningFilled,
} from "@ant-design/icons";
import {
  Row,
  Col,
  Switch,
  Divider,
  Tabs,
  Input,
  Badge,
  Button,
  ConfigProvider,
  Select,
  Tag,
  Avatar,
  Empty,
  Modal,
  Alert,
} from "antd";
import Ribbon from "antd/es/badge/Ribbon";
import React, { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Buttons from "../../components/Button/Button";
import Contrainer from "../../components/Contrainer/Contrainer";
import Text from "../../components/Text/Text";
import { categotyKciDatasource } from "../../datasource/categotyKciDatasource";
import { EmployeeApproveDatasource } from "../../datasource/EmploeeApprove";
import { kciDatasource } from "../../datasource/kciDatasource";
import {
  COMPANY_CODE_MAPPING_DES,
  COMPANY_CODE_MAPPING_LOGO,
} from "../../definitions/Company";
import {
  KCI_EDIT_STATUS,
  KCI_STATUS_COLOR_MAPPING,
} from "../../definitions/KciStatus";
import { kciYearList } from "../../definitions/Years";
import color from "../../resource/color";

const CreateKci: React.FC = () => {
  const navigate = useNavigate();
  const profile = JSON.parse(localStorage.getItem("rainbowProfile")!);
  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;

  const empId: any = pathSplit[3] || 0;
  const year = pathSplit[2] || 0;
  const companyCode = pathSplit[4] || 0;

  const yearList = kciYearList();
  const [search, setSearch] = useState<boolean>(false);
  const [tab, setTab] = useState<any>("Full Year");
  const [tabSearch, setTabSearch] = useState<any>("Full Year");
  const [category, setCategory] = useState<any>();
  const [searchKciData, setSearchKciData] = useState<any>();
  const [deleteKci, setDeleteKci] = useState<any>([]);
  const [deleteKciYear, setDeleteKciYear] = useState<any>([]);
  const [empList, setEmpList] = useState<any>();
  const [filterEmp, setFilterEmp] = useState<any>(undefined);
  const [selectedEmp, setSelectedEmp] = useState<any>([]);
  const [selectedYear, setSelectedYear] = useState<Number>(Number(year));
  const [selectedCate, setSelectedCate] = useState<any>([]);

  const [modalDelete, setModalDelete] = useState<boolean>(false);
  const [modalExit, setModalExit] = useState<boolean>(false);
  const [dataRemove, setDataRemove] = useState<any>();
  const [alertItem, setAlertItem] = useState<boolean>(false);

  const status = [
    { label: "Full Year", color: "" },
    { label: "Q1", color: "" },
    { label: "Q2", color: "" },
    { label: "Q3", color: "" },
    { label: "Q4", color: "" },
  ];

  const [data, setData] = useState<any>(
    status.map((x) => ({
      kciDescription: "",
      categoryId: undefined,
      target: x.label,
      years: year,
      actual: 0,
      weight: 0,
      success: 0,
      employeeId: profile.employeeId,
      orderKCI: 1,
      kciStatus: "",
      isValiDes: false,
      isValiCate: false,
      isValiImpor: false,
    })),
  );
  const [preData, setPreData] = useState<any>();

  const onDragEnd = (result: any, targetLabel: string) => {
    if (!result.destination) return;
    const items = data.filter((a: any) => `${a.target}` === `${targetLabel}`);
    const otherItems = data.filter(
      (a: any) => `${a.target}` !== `${targetLabel}`,
    );
    const [removed] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, removed);
    const reordered = items.map((item: any, idx: number) => ({
      ...item,
      orderKCI: idx + 1,
    }));
    setData([...otherItems, ...reordered]);
  };

  const getKciByEmpId = async () => {
    await kciDatasource
      .getKci({
        years: year,
        employeeId: empId,
        companyCode: companyCode,
      })
      .then(async (res) => {
        const mapData = res?.data?.sort((a: any, b: any) =>
          a.orderKCI > b.orderKCI ? 1 : -1,
        );
        let map: any = [];
        for (let i = 0; status.length > i; i++) {
          const find = mapData.filter((x: any) => x.target === status[i].label);
          if (find.length > 0) {
            await find.forEach((e: any, j: number) => {
              map.push({
                kciId: e.kciId,
                kciDescription: e.kciDescription,
                categoryId: e.categoryId,
                target: e.target,
                years: e.years,
                actual: e.actual,
                weight: e.weight,
                success: e.success,
                employeeId: empId,
                orderKCI: j + 1,
                kciStatus: e.kciStatus,
                isValiDes: false,
                isValiCate: false,
                isValiImpor: false,
              });
            });
          } else {
            map.push({
              kciDescription: "",
              categoryId: undefined,
              target: status[i].label,
              years: year,
              actual: 0,
              weight: 0,
              success: 0,
              employeeId: profile.employeeId,
              orderKCI: 1,
              kciStatus: "DRAFT",
              isValiDes: false,
              isValiCate: false,
              isValiImpor: false,
            });
          }
        }
        setPreData(map);
        setData(map);
      });
  };

  const getCategyKci = async () => {
    await categotyKciDatasource.getCategory().then((res) => {
      setCategory(res.responseData);
    });
  };

  const getAllApprove = async () => {
    await EmployeeApproveDatasource.getAllEmployee({
      page: 1,
      take: 10,
      search: filterEmp,
      companyId: COMPANY_CODE_MAPPING_DES[companyCode],
      isActive: true,
    }).then((res) => {
      setEmpList(res.responseData);
    });
  };

  useEffect(() => {
    getCategyKci();
    if (empId > 0) {
      getKciByEmpId();
    }
    getAllApprove();
  }, [filterEmp]);

  useEffect(() => {
    if (selectedEmp.length > 0) {
      kciDatasource
        .getKci({
          years: selectedYear,
          employeeId: selectedEmp,
          target: tabSearch ? tabSearch : undefined,
          categoryId: selectedCate,
          companyCode: companyCode,
        })
        .then(async (res) => {
          const dataSort = res?.data?.sort((a: any, b: any) =>
            a.orderKCI > b.orderKCI ? 1 : -1,
          );
          setSearchKciData(dataSort);
        });
    } else {
      setSearchKciData([]);
    }
  }, [selectedEmp, tabSearch, selectedYear, selectedCate]);

  const pageTtile = () => {
    return (
      <>
        <Row gutter={8} justify="start">
          <Col>
            <Text
              level={6}
              onClick={() => setModalExit(true)}
              style={{ cursor: "pointer" }}
            >
              Home
            </Text>
          </Col>
          <Col>
            <Text level={6}>/</Text>
          </Col>
          <Col span={21}>
            <Text level={6}>{empId > 0 ? "Edit My KCI" : "Create KCI"} </Text>
          </Col>
          <Col>
            <Row justify={"space-between"} gutter={8}>
              <Col>
                <Avatar
                  style={{ verticalAlign: "middle" }}
                  size={30}
                  src={COMPANY_CODE_MAPPING_LOGO[companyCode]}
                />
              </Col>
              <Col style={{ paddingTop: "6px" }}>
                <Text color="black" fontWeight={400} fontSize={16}>
                  {companyCode}
                </Text>
              </Col>
            </Row>
          </Col>
        </Row>
        <br />
        <Row gutter={8} justify={"space-between"}>
          <Col onClick={() => setModalExit(true)} style={{ cursor: "pointer" }}>
            <LeftOutlined style={{ fontSize: "20px", paddingTop: "4px" }} />
          </Col>
          <Col span={18}>
            <Text level={3} fontWeight={700}>
              {empId > 0 ? "Edit My KCI" : "Create KCI"}
            </Text>
          </Col>
          <Col span={5}>
            <Row gutter={8}>
              <Col style={{ paddingTop: "4px" }}>
                <Text level={5} fontWeight={600}>
                  Compare with Others' KCI
                </Text>
              </Col>
              <Col>
                <div style={{ paddingTop: "4px" }}>
                  <Switch
                    style={{ backgroundColor: search ? "#00C875" : "#4A4B4F" }}
                    checkedChildren={<CheckOutlined />}
                    unCheckedChildren={<CloseOutlined />}
                    defaultChecked={search}
                    onChange={(e) => {
                      setSearch(!search);
                      if (!e) {
                        setSelectedYear(Number(year));
                        setSelectedEmp([]);
                        setSelectedCate(undefined);
                      }
                    }}
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Divider />
      </>
    );
  };

  const addKci = () => {
    if (data.filter((x: any) => x.target === tab).length + 1 <= 10) {
      setAlertItem(
        data.filter((x: any) => x.target === tab).length + 1 == 10
          ? true
          : false,
      );
      setData([
        ...data,
        {
          kciDescription: "",
          categoryId: undefined,
          target: tab,
          years: year,
          actual: 0,
          weight: 0,
          success: 0,
          employeeId: profile.employeeId,
          orderKCI: data.filter((x: any) => x.target === tab).length + 1,
          kciStatus: "DARFT",
          isValiDes: false,
          isValiCate: false,
          isValiImpor: false,
        },
      ]);
    } else {
      setAlertItem(true);
    }
  };

  const onChangeValue = (e: any, t: string, name: string, i?: number) => {
    let payload = data;
    if (name === "des") {
      payload = payload.map((x: any) => {
        const map = x.orderKCI === i && x.target === t;
        if (map) {
          return {
            ...x,
            kciDescription: e,
            isValiDes: false,
            kciStatus: "DRAFT",
          };
        } else {
          return { ...x };
        }
      });
    } else if (name === "category") {
      payload = payload.map((x: any) => {
        const map = x.orderKCI === i && x.target === t;
        if (map) {
          return {
            ...x,
            categoryId: e,
            isValiCate: false,
            kciStatus: "DRAFT",
          };
        } else {
          return { ...x };
        }
      });
    } else if (name === "importance") {
      const reg = /^-?\d*(\.\d*)?$/;
      payload = payload.map((x: any) => {
        const map = x.orderKCI === i && x.target === t;
        if (map) {
          if (reg.test(e) || e === "" || e === "-") {
            return {
              ...x,
              weight: e,
              isValiImpor: false,
              kciStatus: "DRAFT",
            };
          } else {
            return {
              ...x,
            };
          }
        } else {
          return { ...x };
        }
      });
    } else if (name === "actual") {
      const reg = /^-?\d*(\.\d*)?$/;
      payload = payload.map((x: any) => {
        const map = x.orderKCI === i && x.target === t;
        if (map) {
          if (reg.test(e) || e === "" || e === "-") {
            return {
              ...x,
              actual: e,
            };
          } else {
            return {
              ...x,
            };
          }
        } else {
          return { ...x };
        }
      });
    }
    setData(payload);
  };

  const removeRow = async () => {
    if (dataRemove?.kciId) {
      let kciIdList: any = [];
      let kciIdFullYear: any = [];
      if (tab.includes("Year") && dataRemove.kciStatus?.includes("APPROVE")) {
        kciIdFullYear.push(...deleteKciYear, dataRemove.kciId);
        setDeleteKciYear(kciIdFullYear);
      } else {
        kciIdList.push(...deleteKci, dataRemove?.kciId);
        setDeleteKci(kciIdList);
      }
    }
    let payload = data;
    let row: number = 0;
    const filterData = payload
      .filter(
        (x: any) =>
          x.target !== dataRemove?.target || x.orderKCI !== dataRemove?.row + 1,
      )
      .map((y: any) => {
        const find = y.target === dataRemove?.target;
        if (find) {
          row = row + 1;
          return { ...y, orderKCI: row };
        } else {
          return { ...y };
        }
      });
    setDataRemove({});
    setData(filterData);
    setModalDelete(false);
  };

  const save = async (action: string) => {
    let payload = data;
    payload = payload.map((e: any, i: number) => {
      let findYear = e.target.includes("Full");
      if (findYear) {
        return {
          ...e,
          actual: Number(e.actual),
          weight: Number(e.weight),
          isValiDes: !e.kciDescription ? true : false,
          isValiCate: !e.categoryId ? true : false,
          isValiImpor: !e.weight ? true : false,
        };
      } else {
        return {
          ...e,
          actual: Number(e.actual),
          weight: Number(e.weight),
          //isValiCate: !e.categoryId && e.kciDescription ? true : false,
          kciStatus: action === "submit" ? "APPROVE" : e.kciStatus,
        };
      }
    });

    const checkValidate = payload.filter(
      (x: any) =>
        x.target === "Full Year" &&
        (x.isValiDes || x.isValiImpor || x.isValiCate),
    );

    if (checkValidate.length > 0) {
      setTab("Full Year");
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "กรุณากรอกข้อมูลให้ครบ",
        showConfirmButton: true,
        width: 360,
      }).then((value) => {
        if (value.isConfirmed) {
          payload = payload.map((e: any, i: number) => {
            return {
              ...e,
              kciStatus: e.kciStatus,
              companyCode: companyCode,
            };
          });
          setData(payload);
        }
      });
    } else {
      payload = payload.map((e: any, i: number) => {
        if (e.kciId) {
          return {
            ...e,
            updateBy: `${profile.firstname} ${profile.lastname}`,
            kciStatus:
              action === "submit" && e.target.includes("Full")
                ? e.kciStatus.includes("DRAFT") ||
                  e.kciStatus.includes("REJECT")
                  ? "WAIT_APPROVE"
                  : e.kciStatus
                : e.kciStatus,
            companyCode: companyCode,
          };
        } else {
          return {
            ...e,
            createBy: `${profile.firstname} ${profile.lastname}`,
            kciStatus:
              action === "submit" && e.target.includes("Full")
                ? e.kciStatus.includes("DRAFT") ||
                  e.kciStatus.includes("REJECT")
                  ? "WAIT_APPROVE"
                  : e.kciStatus
                : e.kciStatus,
            companyCode: companyCode,
          };
        }
      });
      payload = payload.filter((x: any) => x.kciDescription);
      setData(payload);

      if (deleteKci.length > 0) {
        await kciDatasource
          .deleteKci({
            kciId: deleteKci,
            isApproveDelete: true,
            isCancelApproveDelete: false,
          })
          .then((res) => {
            return res;
          });
      }
      if (deleteKciYear.length > 0) {
        let payloadReqDelete: any = [];
        deleteKciYear.map(async (x: any) => {
          const find = preData.find((y: any) => `${y.kciId}` === `${x}`);
          payloadReqDelete.push({
            kciId: find.kciId,
            kciDescription: find.kciDescription,
            categoryId: find.categoryId,
            target: find.target,
            years: find.years,
            actual: find.actual,
            weight: find.weight,
            success: find.success,
            employeeId: find.employeeId,
            updateBy: `${profile.firstname} ${profile.lastname}`,
            //isCancelDelete: false,
            kciStatus: "WAIT_APPROVE_DELETE",
            companyCode: companyCode,
          });
        });
        await kciDatasource.updateKci(payloadReqDelete).then((res) => res);
      }

      if (empId > 0) {
        await kciDatasource.updateKci(payload).then((res) => {
          if (res.success) {
            Swal.fire({
              position: "center",
              icon: "success",
              title:
                action === "draft"
                  ? "บันทึกแบบร่างสำเร็จ"
                  : "ยืนยันการส่งคำขออนุมัติสำเร็จ",
              showConfirmButton: true,
              width: 360,
            }).then((value) => {
              if (value.isConfirmed) {
                navigate(`/kci/${companyCode}`);
              }
            });
          }
        });
      } else {
        await kciDatasource.createKci(payload).then((res) => {
          if (res.success) {
            Swal.fire({
              position: "center",
              icon: "success",
              title:
                action === "draft"
                  ? "บันทึกแบบร่างสำเร็จ"
                  : "ยืนยันการส่งคำขออนุมัติสำเร็จ",
              showConfirmButton: true,
              width: 400,
            }).then((value) => {
              if (value.isConfirmed) {
                navigate(`/kci/${companyCode}`);
              }
            });
          }
        });
      }
    }
  };

  return (
    <>
      <Contrainer>
        {pageTtile()}
        <ConfigProvider
          theme={{
            components: {
              Tabs: {
                //cardBg: color.navy,
                //itemSelectedColor: color.navy,
              },
            },
          }}
        >
          {alertItem && (
            <div>
              <Alert
                style={{
                  backgroundColor: "#ffffff",
                  borderColor: "#F3F4FB",
                }}
                message={
                  <>
                    <Text level={5} fontWeight={700}>
                      ไม่สามารถเพิ่มรายการใหม่ได้
                    </Text>{" "}
                    <Text level={6} color="navy" fontWeight={500}>
                      คุณสามารถสร้าง KCI ได้สูงสุด 10 รายการ
                    </Text>
                  </>
                }
                icon={
                  <ExclamationCircleTwoTone style={{ color: color.navy }} />
                }
                onClose={() => setAlertItem(false)}
                showIcon
                closable
              />
              <br />
            </div>
          )}
          <Tabs
            size="middle"
            //defaultValue={tab}
            defaultActiveKey={tab}
            type="card"
            onChange={(key) => {
              setTab(key);
            }}
            items={status.map((s: any, i: any) => {
              return {
                label: (
                  <>
                    <Text
                      level={6}
                      color={tab === s.label ? "navy" : "black"}
                      fontWeight={700}
                    >
                      {s.label}
                    </Text>
                  </>
                ),
                key: s.label,
                children: (
                  <>
                    <div
                      style={{
                        backgroundColor: color.navy,
                        borderRadius: "8px",
                        height: "40px",
                        padding: "9px",
                      }}
                    >
                      <Row justify={"space-around"} gutter={8}>
                        <Col span={empId > 0 ? 13 : 16}>
                          <Text color="white" fontWeight={700} fontSize={16}>
                            Description{" "}
                            <span style={{ color: color.error }}>*</span>
                          </Text>
                        </Col>
                        <Col span={4} style={{ paddingLeft: "25px" }}>
                          <Text color="white" fontWeight={700} fontSize={16}>
                            4D{" "}
                            {tab.includes("Year") && (
                              <span style={{ color: color.error }}>*</span>
                            )}
                          </Text>
                        </Col>
                        {empId > 0 && (
                          <Col span={3} style={{ paddingLeft: "25px" }}>
                            <Text color="white" fontWeight={700} fontSize={16}>
                              Actual
                            </Text>
                          </Col>
                        )}
                        <Col span={4} style={{ paddingLeft: "25px" }}>
                          <Text color="white" fontWeight={700} fontSize={16}>
                            Importance
                            {tab.includes("Year") && (
                              <span style={{ color: color.error }}>*</span>
                            )}
                          </Text>
                        </Col>
                      </Row>
                    </div>
                    <div style={{ paddingTop: "8px" }} />
                    <div
                      style={{
                        backgroundColor: "#E8E9F8",
                        borderTopRightRadius: "5px",
                        borderTopLeftRadius: "5px",
                        height: "40px",
                        padding: "8px",
                      }}
                      key={s.label}
                    >
                      <Row justify={"space-around"} gutter={8}>
                        <Col span={20}>
                          <Text color="navy" fontSize={14}>
                            Total{" "}
                            {
                              data.filter((x: any) => x.target === s.label)
                                .length
                            }{" "}
                            / 10 Items
                          </Text>
                        </Col>
                        <Col span={4}>
                          <Text color="navy" fontSize={14}>
                            Total <b>Importance</b>{" "}
                            {data
                              .filter((a: any) => a.target === s.label)
                              .map((x: any) => Number(x.weight))
                              .reduce(
                                (acc: any, curr: any) => acc + curr,
                                0,
                              )}{" "}
                            %
                          </Text>
                        </Col>
                      </Row>
                    </div>
                    <DragDropContext
                      onDragEnd={(result) => onDragEnd(result, s.label)}
                    >
                      <Droppable droppableId={`droppable-${s.label}`}>
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                          >
                            {data
                              ?.filter(
                                (a: any) => `${a.target}` === `${s.label}`,
                              )
                              ?.map((x: any, i: any) => (
                                <Draggable
                                  key={
                                    x.kciId
                                      ? String(x.kciId)
                                      : `${s.label}-${x.orderKCI}-${i}`
                                  }
                                  draggableId={
                                    x.kciId
                                      ? String(x.kciId)
                                      : `${s.label}-${x.orderKCI}-${i}`
                                  }
                                  index={i}
                                >
                                  {(provided, snapshot) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      style={{
                                        ...provided.draggableProps.style,
                                        backgroundColor: snapshot.isDragging
                                          ? "#e0e7ff"
                                          : "#F4F4F6",
                                        paddingTop: "8px",
                                        paddingBottom: "8px",
                                      }}
                                    >
                                      <Row justify={"space-around"} gutter={8}>
                                        <Col
                                          style={{
                                            paddingTop: "10px",
                                            paddingLeft: "20px",
                                          }}
                                        >
                                          <HolderOutlined
                                            style={{
                                              fontSize: "18px",
                                              cursor: "move",
                                              color: color.navy,
                                            }}
                                          />
                                        </Col>
                                        <Col
                                          span={1}
                                          style={{
                                            paddingTop: "6px",
                                            paddingLeft: "20px",
                                          }}
                                        >
                                          <Badge
                                            count={x.orderKCI}
                                            color={color.navy}
                                          />{" "}
                                        </Col>
                                        <Col span={empId > 0 ? 11 : 14}>
                                          <Row>
                                            {empId > 0 &&
                                              x.kciStatus &&
                                              x.target.includes("Year") && (
                                                <Col span={1}>
                                                  <ConfigProvider
                                                    theme={{
                                                      token: { fontSize: 25 },
                                                    }}
                                                  >
                                                    <>
                                                      <Badge
                                                        color={
                                                          KCI_STATUS_COLOR_MAPPING[
                                                            x.kciStatus
                                                          ]
                                                        }
                                                      />
                                                    </>
                                                  </ConfigProvider>
                                                </Col>
                                              )}
                                            <Col span={23}>
                                              {x.kciStatus.includes(
                                                "DELETE",
                                              ) ? (
                                                <Ribbon
                                                  text={
                                                    <Text
                                                      fontSize={12}
                                                      fontWeight={500}
                                                      color="white"
                                                    >
                                                      <HistoryOutlined />{" "}
                                                      Awaiting deletion approval
                                                    </Text>
                                                  }
                                                  placement="end"
                                                  color={"#F79626"}
                                                >
                                                  <Input
                                                    disabled={true}
                                                    style={{
                                                      backgroundColor:
                                                        color.lightgray,
                                                      height: "40px",
                                                      borderColor: color.error,
                                                      color: color.black,
                                                    }}
                                                    bordered={x.isValiDes}
                                                    value={x.kciDescription}
                                                  />
                                                </Ribbon>
                                              ) : (
                                                <Input
                                                  disabled={
                                                    KCI_EDIT_STATUS[x.kciStatus]
                                                  }
                                                  style={{
                                                    backgroundColor:
                                                      KCI_EDIT_STATUS[
                                                        x.kciStatus
                                                      ]
                                                        ? color.lightgray
                                                        : color.white,
                                                    height: "40px",
                                                    borderColor: color.error,
                                                    color: color.black,
                                                  }}
                                                  placeholder="Description"
                                                  bordered={x.isValiDes}
                                                  value={x.kciDescription}
                                                  autoComplete="off"
                                                  onChange={(e: any) =>
                                                    onChangeValue(
                                                      e.target.value,
                                                      s.label,
                                                      "des",
                                                      i + 1,
                                                    )
                                                  }
                                                />
                                              )}
                                            </Col>
                                            {x.isValiDes && (
                                              <div
                                                style={{
                                                  width: "100%",
                                                  paddingLeft: "40px",
                                                }}
                                              >
                                                <WarningFilled
                                                  style={{ color: color.error }}
                                                />{" "}
                                                <Text color="error" level={6}>
                                                  Please enter a Description
                                                </Text>
                                              </div>
                                            )}
                                          </Row>
                                        </Col>
                                        <Col span={4}>
                                          <Select
                                            placeholder="4D"
                                            disabled={
                                              tab !== "Full Year" ||
                                              KCI_EDIT_STATUS[x.kciStatus]
                                            }
                                            style={{
                                              backgroundColor:
                                                tab !== "Full Year" ||
                                                KCI_EDIT_STATUS[x.kciStatus]
                                                  ? color.lightgray
                                                  : color.white,
                                              height: "40px",
                                              width: "100%",
                                              color: color.black,
                                            }}
                                            status={x.isValiCate ? "error" : ""}
                                            value={x.categoryId}
                                            bordered={x.isValiCate}
                                            options={category?.map((c: any) => {
                                              return {
                                                label: (
                                                  <div
                                                    style={{
                                                      backgroundColor:
                                                        c.colorCode,
                                                      borderRadius: "5px",
                                                      paddingLeft: "5px",
                                                    }}
                                                  >
                                                    <Text
                                                      level={6}
                                                      color="white"
                                                      fontWeight={500}
                                                    >
                                                      {c.categoryName}
                                                    </Text>
                                                  </div>
                                                ),
                                                value: c.categoryId,
                                                key: c.categoryId,
                                              };
                                            })}
                                            onChange={(e: any) =>
                                              onChangeValue(
                                                e,
                                                s.label,
                                                "category",
                                                i + 1,
                                              )
                                            }
                                          />
                                          {x.isValiCate && (
                                            <div style={{ width: "100%" }}>
                                              <WarningFilled
                                                style={{ color: color.error }}
                                              />{" "}
                                              <Text color="error" level={6}>
                                                Please select a Category
                                              </Text>
                                            </div>
                                          )}
                                        </Col>
                                        {empId > 0 && (
                                          <Col span={3}>
                                            <Input
                                              disabled={
                                                x.kciStatus === "APPROVE"
                                                  ? false
                                                  : true
                                              }
                                              style={{
                                                color: color.black,
                                                backgroundColor:
                                                  x.kciStatus === "APPROVE"
                                                    ? color.white
                                                    : color.lightgray,
                                                height: "40px",
                                              }}
                                              suffix="%"
                                              value={x.actual}
                                              placeholder="Actual"
                                              autoComplete="off"
                                              onChange={(e: any) =>
                                                onChangeValue(
                                                  e.target.value,
                                                  s.label,
                                                  "actual",
                                                  i + 1,
                                                )
                                              }
                                            />
                                          </Col>
                                        )}
                                        <Col span={3}>
                                          <Input
                                            disabled={
                                              tab !== "Full Year" ||
                                              KCI_EDIT_STATUS[x.kciStatus]
                                            }
                                            style={{
                                              color: color.black,
                                              backgroundColor:
                                                tab !== "Full Year" ||
                                                KCI_EDIT_STATUS[x.kciStatus]
                                                  ? color.lightgray
                                                  : color.white,
                                              height: "40px",
                                              borderColor: color.error,
                                            }}
                                            suffix="%"
                                            value={x.weight}
                                            placeholder="Importance"
                                            bordered={x.isValiImpor}
                                            autoComplete="off"
                                            onChange={(e: any) =>
                                              onChangeValue(
                                                e.target.value,
                                                s.label,
                                                "importance",
                                                i + 1,
                                              )
                                            }
                                          />
                                          {x.isValiImpor && (
                                            <div style={{ width: "100%" }}>
                                              <WarningFilled
                                                style={{ color: color.error }}
                                              />{" "}
                                              <Text color="error" level={6}>
                                                Please enter Importance
                                              </Text>
                                            </div>
                                          )}
                                        </Col>
                                        <Col span={1}>
                                          {(data.length > 0 || i > 0) &&
                                            !KCI_EDIT_STATUS[x.kciStatus] &&
                                            (empId ? (
                                              <DeleteOutlined
                                                style={{
                                                  fontSize: "16px",
                                                  paddingTop: "12px",
                                                  cursor: "pointer",
                                                  color: color.error,
                                                }}
                                                onClick={() => {
                                                  setModalDelete(true);
                                                  setDataRemove({
                                                    target: s.label,
                                                    row: i,
                                                    kciId: x.kciId,
                                                    kciStatus: x.kciStatus,
                                                  });
                                                }}
                                              />
                                            ) : (
                                              <CloseOutlined
                                                style={{
                                                  fontSize: "16px",
                                                  paddingTop: "12px",
                                                  cursor: "pointer",
                                                }}
                                                onClick={() => {
                                                  setModalDelete(true);
                                                  setDataRemove({
                                                    target: s.label,
                                                    row: i,
                                                    kciId: undefined,
                                                    kciStatus: x.kciStatus,
                                                  });
                                                }}
                                              />
                                            ))}
                                        </Col>
                                      </Row>
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                            {provided.placeholder}
                            <div
                              style={{
                                backgroundColor: "#F4F4F6",
                                height: "55px",
                                padding: "8px",
                              }}
                            >
                              <Button
                                type="dashed"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  borderColor: color.navy,
                                  backgroundColor: "#F4F4F6",
                                }}
                                onClick={() => addKci()}
                              >
                                <PlusOutlined
                                  style={{
                                    fontSize: "20px",
                                    color: color.navy,
                                  }}
                                />
                                <Text
                                  fontSize={20}
                                  fontWeight={700}
                                  color={"navy"}
                                >
                                  Create New KCI
                                </Text>
                              </Button>
                            </div>
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                  </>
                ),
              };
            })}
          />
        </ConfigProvider>
        <br />
        {search && (
          <div
            style={{
              border: "solid",
              borderRadius: "8px",
              borderColor: "#F3F4FB",
              padding: "15px",
            }}
          >
            <Row justify={"space-between"} gutter={8}>
              <Col span={10}>
                <Text level={4} fontWeight={700}>
                  Compare with Others' KCI
                </Text>
              </Col>
              <Col span={2}>
                <Select
                  style={{
                    backgroundColor: color.white,
                    height: "40px",
                    width: "100%",
                  }}
                  value={selectedYear}
                  placeholder="ค้นหาปี"
                  bordered={true}
                  onChange={(e) => setSelectedYear(e)}
                  options={yearList.map((x: any) => {
                    return {
                      label: (
                        <Text color="black" fontWeight={400} fontSize={14}>
                          {x}
                        </Text>
                      ),
                      value: x,
                      key: x,
                    };
                  })}
                />
              </Col>
              <Col span={8}>
                <Select
                  placeholder="Search by Name/ Position"
                  style={{ width: "100%", height: "100%" }}
                  allowClear
                  showSearch
                  filterOption={false}
                  onSearch={(e) => {
                    if (e) {
                      setFilterEmp(e);
                    } else {
                      setFilterEmp(undefined);
                    }
                  }}
                  onSelect={(e) => {
                    setFilterEmp(undefined);
                    setSelectedEmp([e]);
                  }}
                  onClear={() => {
                    setFilterEmp(undefined);
                    setSelectedEmp([]);
                  }}
                  options={empList?.map((y: any) => {
                    return {
                      label: (
                        <Row gutter={8} justify="start">
                          <Col>
                            {y?.imagePath ? (
                              <Avatar src={y?.imagePath} />
                            ) : (
                              <Avatar>
                                {y?.firstname.substring(0, 1) || ""}
                                {y?.lastname.substring(0, 1) || ""}
                              </Avatar>
                            )}
                          </Col>
                          <Col>
                            <Text fontWeight={700}>
                              {y?.firstname + " " + y?.lastname}/
                              {y?.position.positionName}
                            </Text>
                          </Col>
                        </Row>
                      ),
                      value: y?.employeeId,
                      key: y?.firstname + " " + y?.lastname,
                    };
                  })}
                />
              </Col>
              <Col span={4}>
                <Select
                  allowClear
                  style={{
                    backgroundColor: color.white,
                    height: "40px",
                    width: "100%",
                  }}
                  placeholder="Select 4D"
                  bordered={true}
                  options={category?.map((c: any) => {
                    return {
                      label: (
                        <div
                          style={{
                            backgroundColor: c.colorCode,
                            borderRadius: "5px",
                            paddingLeft: "5px",
                          }}
                        >
                          <Text level={6} color="white">
                            {c.categoryName}
                          </Text>
                        </div>
                      ),
                      value: c.categoryId,
                      key: c.categoryId,
                    };
                  })}
                  onChange={(e: any) => {
                    if (e) {
                      setSelectedCate(e);
                    } else {
                      setSelectedCate([]);
                    }
                  }}
                />
              </Col>
            </Row>
            <Tabs
              size="middle"
              type="card"
              onChange={(key) => setTabSearch(key)}
              items={status.map((s: any, i: any) => {
                return {
                  label: (
                    <>
                      <Text level={6} color="navy" fontWeight={700}>
                        {s.label}
                      </Text>
                    </>
                  ),
                  key: s.label,
                  children: (
                    <>
                      {searchKciData?.length > 0 ? (
                        <>
                          <div
                            style={{
                              backgroundColor: color.navy,
                              borderTopRightRadius: "8px",
                              borderTopLeftRadius: "8px",
                              height: "40px",
                              padding: "9px",
                            }}
                          >
                            <Row justify={"space-around"} gutter={8}>
                              <Col span={16}>
                                <Text
                                  color="white"
                                  fontWeight={700}
                                  fontSize={16}
                                >
                                  Description
                                </Text>
                              </Col>
                              <Col span={4}>
                                <Text
                                  color="white"
                                  fontWeight={700}
                                  fontSize={16}
                                >
                                  4D
                                </Text>
                              </Col>
                              <Col span={4}>
                                <Text
                                  color="white"
                                  fontWeight={700}
                                  fontSize={16}
                                >
                                  Importance
                                </Text>
                              </Col>
                            </Row>
                          </div>
                          <div>
                            {searchKciData?.map((x: any, i: any) => (
                              <div
                                style={{
                                  backgroundColor: "#F4F4F6",
                                  height: "55px",
                                  padding: "8px",
                                }}
                              >
                                <Row justify={"space-around"} gutter={8}>
                                  <Col span={13}>
                                    <Text>
                                      {i + 1}. {x?.kciDescription}
                                    </Text>
                                  </Col>
                                  <Col span={5}>
                                    <Tag
                                      color={x?.category?.colorCode}
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                      }}
                                    >
                                      <Row justify={"center"}>
                                        <Text color="white">
                                          {x?.category?.categoryName}
                                        </Text>
                                      </Row>
                                    </Tag>
                                  </Col>
                                  <Col span={3}>
                                    <Text>{x?.weight} %</Text>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                          </div>
                        </>
                      ) : (
                        <Empty
                          description={
                            <Text level={6} color="gray">
                              Please Select a Person to Compare KCI
                            </Text>
                          }
                        />
                      )}
                    </>
                  ),
                };
              })}
            />
          </div>
        )}
        <br />
        <Row justify={"end"} gutter={8}>
          <Col>
            <Button
              style={{
                backgroundColor: color.white,
                borderColor: color.navy,
                height: "40px",
              }}
              onClick={() => save("draft")}
            >
              <Text color="navy" fontWeight={700}>
                Save Draft
              </Text>
            </Button>
          </Col>
          <Col>
            <Button
              style={{
                backgroundColor: color.navy,
                borderColor: "#F4F6F4",
                height: "40px",
              }}
              onClick={() => save("submit")}
            >
              <Text color="white" fontWeight={700}>
                Submit for Approval
              </Text>
            </Button>
          </Col>
        </Row>
        <br />
      </Contrainer>
      {modalDelete && (
        <Modal
          title={
            <>
              <Text fontWeight={700} level={2}>
                ยืนยันการลบ KCI
              </Text>
              <Divider />
            </>
          }
          centered
          open={modalDelete}
          onCancel={() => setModalDelete(!modalDelete)}
          footer={() => (
            <>
              <Buttons
                text="Cancal"
                bgColor={color.white}
                textColor="black"
                onClick={() => setModalDelete(!modalDelete)}
              />
              <Buttons
                text="Confirm"
                onClick={() => removeRow()}
                bgColor={color.error}
              />
            </>
          )}
        >
          <Text>
            โปรดตรวจสอบรายละเอียดก่อนยืนยันการลบ
            เนื่องจากอาจส่งผลต่อการแสดงผลข้อมูลในระบบ หากเลือก KCI ที่มีสถานะ
            ‘อนุมัติ’ ใน Full Year
            คำขอจะถูกส่งให้หัวหน้าเพื่อพิจารณาอนุมัติการลบ
          </Text>
        </Modal>
      )}
      {modalExit && (
        <Modal
          title={
            <>
              <Text fontWeight={700} level={2}>
                ยืนยันการยกเลิก{empId > 0 ? "แก้ไข" : "การสร้าง"} KCI
              </Text>
              <Divider />
            </>
          }
          centered
          open={modalExit}
          onCancel={() => setModalExit(!modalExit)}
          footer={() => (
            <>
              <Buttons
                text="Cancel"
                bgColor={color.white}
                textColor="black"
                onClick={() => setModalExit(!modalExit)}
              />
              <Buttons
                text="Confirm"
                onClick={() => navigate(`/kci/${companyCode}`)}
                bgColor={color.error}
              />
            </>
          )}
        >
          <Text>
            โปรดตรวจสอบรายละเอียดการยกเลิก{empId > 0 ? "แก้ไข" : "การสร้าง"} KCI
            ก่อนกดยืนยัน เพราะอาจทำให้ข้อมูลที่สร้างขึ้นไม่ถูกบันทึก
          </Text>
        </Modal>
      )}
    </>
  );
};

export default CreateKci;
